export default __webpack_public_path__ + "static/media/Uplift.dae14ac7.svg";